import { render } from "./dialog-config.vue?vue&type=template&id=8c2e7ec4&scoped=true"
import script from "./dialog-config.vue?vue&type=script&lang=js"
export * from "./dialog-config.vue?vue&type=script&lang=js"

import "./dialog-config.vue?vue&type=style&index=0&id=8c2e7ec4&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c2e7ec4"]])

export default __exports__